(function () {
  'use strict';

  class CompartilhamentosCtrl {

    constructor(AlertMessage, Compartilhamentos, Uos, $scope, UoArvoreNivel, $q, Keys, ServiceVfiltro, FactoryVfiltro, $location, $translate, VehiclesMap) {
      this.q = $q;
      this.keys = Keys;
      this.serviceVfiltro = ServiceVfiltro;
      this.alertMessage = AlertMessage;
      this.location = $location;
      this.$scope = $scope;
      this.uoService = Uos;
      this.uoArvoreNivel = UoArvoreNivel;
      this.compartilhamentoService = Compartilhamentos;
      this.compartilhamentos = [];
      this.$translate = $translate;
      this.vehiclesMap = VehiclesMap;
      ServiceVfiltro.init(FactoryVfiltro.get([
        {
          key: this.keys.uo.name
        }
      ]))
      .then(filtro => {
        this.carregarCompartilhamentos(filtro);
        this.roleCadastrar = this.serviceVfiltro.factoryVfiltro.authenticator.hasRole('COMPARTILHAMENTOS_EDITAR');
      });

      this.$scope.translateTipoEntidade = (nomeEntidade) =>{
        if (VehiclesMap[nomeEntidade]) {
          const translatedPath = $translate.instant(`core-permissoes.organizacao.compartilhamentos.shareButton.${VehiclesMap[nomeEntidade]}`);
          return translatedPath;
        }

        return nomeEntidade;
      };
    }

    carregarCompartilhamentos(filtro) {
      this.compartilhamentoService.one('list')
      .getList(filtro.find(x => x.key === this.keys.uo.name).value.id)
      .then(data => {
        this.displayMessages();
        this.compartilhamentos = data.map(uoCompartilhamento => {
          uoCompartilhamento.compartilhamentoRecebidoLista =
            uoCompartilhamento.compartilhamentoRecebidoLista
              .filter(compartilhamentoRecebido => compartilhamentoRecebido.uo.id !== uoCompartilhamento.uo.id);

          return uoCompartilhamento;
        });
      });
    }

    displayMessages() {
      if (this.location.search().saveSuccess && this.location.search().saveSuccess === 'true') {
        this.alertMessage.create({
          type: 'success',
          message: 'Compartilhamento salvo com sucesso.',
          appendTo: '.alerta-aqui'
        });
        this.location.search('saveSuccess', null);
      }

      if (this.location.search().deleteSuccess && this.location.search().deleteSuccess === 'true') {
        this.alertMessage.create({
          type: 'success',
          message: 'Compartilhamento excluído com sucesso.',
          appendTo: '.alerta-aqui'
        });
        this.location.search('deleteSuccess', null);
      }
    }
  }

  /**
   * @ngdoc object
   * @name compartilhamentos.controller:CompartilhamentosCtrl
   *
   * @description
   *
   */
  angular
    .module('compartilhamentos')
    .controller('CompartilhamentosCtrl', CompartilhamentosCtrl);
}());
